import styled from 'styled-components';
import color from '../../configs/color';
// import breakpoints from '../../configs/breakpoints'

const Wrapper = styled.div`
  .component_account_photo {
    .component_account_photo_img {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 172px;
      height: 172px;
      border-radius: 140px;
      background-color: ${color.white};
      border: 1px solid ${color.black6};
      .component_loading_upload {
        position: absolute;
        margin: 0;
        font-size: 48px;
        z-index: 1;
        color: ${color.green1};
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .ant-avatar {
        border: 1px solid #bababa;
        width: 100%;
        height: 100%;
        .ant-avatar-string {
          font-size: 50px;
          top: 50%;
          transform: translate(-50%, -50%) !important;
          position: absolute;
          color: white;
        }
      }
      .component_account_card_text {
        background-color: ${color.orange2};
      }
      .component_account_upload_button {
        position: absolute;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        border-radius: 50px;
        background-color: ${color.green1};
        color: white;
        cursor: pointer;
        .anticon {
          position: absolute;
          color: white;
          font-size: 20px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
`;

export default Wrapper;
